module.exports = __webpack_public_path__ + "files/cad9b89f8106f1ce812aefdfa6f61262.png";


//////////////////
// WEBPACK FOOTER
// ./images/themes/default.png
// module id = 538
// module chunks = 76